import {Component, inject, Input, OnInit} from '@angular/core';
import {CurrencyPipe} from "@angular/common";
import {MatSlideToggle, MatSlideToggleChange} from "@angular/material/slide-toggle";
import {TournamentService} from "../../service/tournament.service";
import {ActivatedRoute} from "@angular/router";
import {Tournament} from "../../model/tournament";
import {FormsModule} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatDialog} from "@angular/material/dialog";
import {SubstituteSelectionComponent} from "../substitute-selection/substitute-selection.component";
import {TournamentPlayer} from "../../model/tournamentPlayer";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";

@Component({
  selector: 'app-tournament-players',
  imports: [
    CurrencyPipe,
    MatSlideToggle,
    FormsModule,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatTab,
    MatTabGroup,
    MatTabLabel
  ],
  templateUrl: './tournament-players.component.html',
  standalone: true,
  styleUrl: './tournament-players.component.scss'
})
export class TournamentPlayersComponent implements OnInit {

  @Input() tournament: Tournament;

  constructor(
    private tournamentService: TournamentService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    if (!this.tournament) {
      const id = Number(this.route.snapshot.paramMap.get('id'));
      if (id) {
        this.tournamentService.getById(Number(id)).subscribe(data => {
          this.tournament = data;
        });
      }
    }
  }

  playerPaid($event: MatSlideToggleChange, playerId: number) {
    this.tournamentService.playerPaid(this.tournament.id, playerId, $event.checked).subscribe(() => {
      this._snackBar.open('Opgeslagen.');
    });
  }

  playerPresent($event: MatSlideToggleChange, playerId: number) {
    this.tournamentService.playerPresent(this.tournament.id, playerId, $event.checked).subscribe(() => {
      this._snackBar.open('Opgeslagen.');
    });
  }

  substituteSelectionDialog = inject(MatDialog);

  findSubstitute(player: TournamentPlayer) {
    this.substituteSelectionDialog.open(SubstituteSelectionComponent, {
      data: {
        player: player,
        availablePlayers: this.tournament.tournamentPlayers
      },
      minWidth: '800px',
      minHeight: '250px'
    }).afterClosed().subscribe(result => {
      if (result != undefined) {
        this.tournamentService.playerSubstitute(this.tournament.id, player.playerId, result.substitutions).subscribe(data => {
          this.tournament = data;
        });
      }
    });

  }

  hasSubstitutes(tournamentPlayer: TournamentPlayer) {
    return tournamentPlayer.substitutions.filter(s => s.substitute != null && s.substitute >= 0).length > 0;
  }
}
